export default "__VITE_ASSET__BhVWAZeL__"